import React from 'react';
import { FileWarning } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';

const UnsavedChangesDialog = ({
  open,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onOpenChange={(nextOpen) => {
      if (!nextOpen) onCancel?.();
    }}
  >
    <DialogContent
      priority
      hideClose
      className="max-w-md gap-0 p-0 overflow-hidden"
      data-testid="unsaved-changes-dialog"
      onEscapeKeyDown={(event) => {
        event.preventDefault();
        onCancel?.();
      }}
    >
      <div className="p-6">
        <DialogHeader className="space-y-4 text-left">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
            <FileWarning size={20} />
          </div>
          <div className="space-y-2">
            <DialogTitle>Unsaved changes</DialogTitle>
            <DialogDescription>
              Are you sure you want to discard the changes?
            </DialogDescription>
          </div>
        </DialogHeader>
      </div>
      <DialogFooter className="border-t border-slate-200 bg-slate-50 px-6 py-4 sm:justify-end sm:space-x-2">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          data-testid="unsaved-changes-cancel"
        >
          Cancel
        </Button>
        <Button
          type="button"
          className="bg-blue-600 hover:bg-blue-700"
          onClick={onConfirm}
          data-testid="unsaved-changes-confirm"
        >
          Confirm
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default UnsavedChangesDialog;
